<template>
    <div>
        <div class="col-md-12 row py-10">
            <div class="col-md-5">
                <v-carousel :continuous="true"
                            cycle
                            :show-arrows="archives.images.length > 1"
                            hide-delimiter-background
                            delimiter-icon="mdi-minus"
                            height="auto"
                            width="auto"
                >
                    <v-carousel-item
                            v-for="(image, i) in archives.images"
                            :key="image"
                            :src="image"
                    >
                    </v-carousel-item>
                </v-carousel>
            </div>
            <div class="col-md">
                <p><span class="font-weight-bolder" style="color: darkblue">دسته بندی :</span> <span
                        class="font-weight-bold" v-html="archives.category"></span></p>
                <p class="mx-auto" v-if="archives.city"><span class="font-weight-bolder"
                                                              style="color: darkblue">شهر : </span><span
                        class="font-weight-bold"
                        v-html="archives.city"></span></p>
                <p class="mx-auto" v-if="archives.province"><span class="font-weight-bolder" style="color: darkblue">استان : </span>
                    <span class="font-weight-bold"
                          v-html="archives.province"></span></p>
                <p><span class="font-weight-bolder" style="color: darkblue">مبلغ اصلی : </span><span
                        class="font-weight-bold" style="text-decoration:line-through;color: red">{{
                        (archives.amount) | currency
                    }}</span> ﷼</p>
                <p><span class="font-weight-bolder" style="color: darkblue">مبلغ قابل پرداخت : </span><span
                        class="font-weight-bold" style="color: green">{{ archives.final_price | currency }}</span> ﷼</p>
                <p v-if="archives.count!== ''"><span class="font-weight-bolder" style="color: darkblue">تعداد رکورد : </span><span
                        class="font-weight-bold"
                        v-html="archives.count!== ' ' ? archives.count : 'ندارد'"></span></p>
                <p class="mx-auto"><span class="font-weight-bolder" style="color: darkblue">عنوان : </span><span
                        class="font-weight-bold">{{ archives.title }}</span></p>
                 <span  v-if="archives.description">
                   <span class="font-weight-bolder" style="color: darkblue">توضیحات : </span>
                  <span v-if="archives.description">
                    <p class="font-weight-bold py-0" v-for="(line) in archives.description.split('\n')" :key="line"> {{ line }}</p>
                  </span>
                 </span >
                <v-btn v-if="!bought" @click="buyProduct(information)" rounded outlined
                       class="mt-4 float-left btn-buy">
                    <span class="fa fa-shopping-cart mr-2"></span>
                    خرید
                </v-btn>
                <v-btn v-else @click="downloader(information)" rounded outlined
                       class="mt-4 float-left btn-download">
                    <span class="material-icons">file_download</span>
                    دانلود فایل
                </v-btn>
            </div>

            <a :href="downloadUrl" id="dl" ref="dl" :download="name"></a>
        </div>
    </div>
</template>

<script>
import {Axios2} from "../../../main";

export default {
    name: "moreInformation",
    props: {
        information: {
            default: ''
        },
        bought: {
            default: false,
        }
    },
    data() {
        return {
            archives: [],
            downloadUrl: '',
            name: 'بانک'
        }
    },
    methods: {
        getArchives() {
            Axios2.get(`user/archives/${this.information}`).then((response) => {
                this.archives = response.data.data;
            });
        },
        buyProduct(id) {
            this.$modal.yesNo('تایید خرید!', 'آیا از خرید این بانک اطلاعاتی اطمینان دارید؟ پس از خرید، عودت مبلغ تحت هیچ شرایطی امکان پذیر نمی باشد.', 'neg').then((x) => {
                if (x === true) {
                    Axios2.put(`user/shop/${id}`).then((res) => {
                        this.$nextTick(() => {
                            this.$modal.success('موفق!', res.data.message);
                        })

                    }).catch((error) => {
                        this.$nextTick(() => {
                            this.$modal.error('خطا!', '', error.response.data.message)
                        })
                    });
                }
            })
        },
        downloader(id) {
            Axios2.post(`/user/download/${id}`, [], {
                responseType: "blob",
            }).then((x) => {
                this.name = decodeURI(x.headers["name"]);
                this.downloadUrl = window.URL.createObjectURL(new Blob([x.data]));
               this.$nextTick(()=>{
                   this.$refs.dl.click();
               })
            })
        },
    },
    mounted() {
        this.getArchives();
        this.downloadUrl = ''
    }
}
</script>

<style scoped>

</style>